<template>
    <v-dialog v-model="dialog" width=80%>
        <v-card>
            <v-container>
                <v-row cols="12" no-gutters dense>
                    <v-col cols="3" class="mt-8">
                        <v-card class="ml-6" flat>
                            <v-container>
                                <div v-if="review.source === 'Booking'"><v-img :src="getImgSrc('booking')" alt="" :aspect-ratio="getImgAspectRatio('booking')" :width="getImgWidth('booking')"/></div>
                                <div v-if="review.source === 'Airbnb'"><v-img :src="getImgSrc('airbnb')" alt="" :aspect-ratio="getImgAspectRatio('airbnb')" :width="getImgWidth('airbnb')"/></div>
                                <div v-if="review.source === 'VillaForYou'"><v-img :src="getImgSrc('vfy')" alt="" :aspect-ratio="getImgAspectRatio('vfy')" :width="getImgWidth('vfy')"/></div>
                                <div v-if="review.source === 'Holidu'"><v-img :src="getImgSrc('holidu')" alt="" :aspect-ratio="getImgAspectRatio('holidu')" :width="getImgWidth('holidu')"/></div>
                                <div v-if="review.source === 'Vrbo'"><v-img :src="getImgSrc('vrbo')" alt="" :aspect-ratio="getImgAspectRatio('vrbo')" :width="getImgWidth('vrbo')"/></div>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="mt-8">
                        <v-card flat>
                            <v-container>
                                <table>
                                    <tr>
                                        <td style="width: 130px;">
                                            <b>Accommodation</b>&nbsp;&nbsp;&nbsp;&nbsp;{{ review.huis_code }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 300px;">{{ review.huis_naam }}</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 300px; font-weight: 500; font-size: 20pt; font-style: italic; color: orange" v-if="review.copy">Internal copy</td>                                        
                                    </tr>                                    
                                    <tr>
                                        <td style="width: 300px; font-weight: 500; font-size: 10pt; color: orange" v-if="review.copy">Booking {{ review.huov_code }} (Org: {{ review.plan_code }})</td>
                                    </tr>
                                </table>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="mt-8">
                        <v-card flat>
                            <v-container>
                                <table>
                                    <tr>
                                        <td style="width: 475px;">
                                            <div style="display: flex; flex-direction: row; align-items: center;">
                                                <div><b>Average score accommodation</b></div>
                                                <div v-if="review.avgReviewScoreRnd===0">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score0" style="color: lightgrey !important">?</v-avatar>
                                                </div>
                                                <div v-if="review.avgReviewScoreRnd===1">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score1">{{review.avgReviewScore}}</v-avatar>
                                                </div>
                                                <div v-else-if="review.avgReviewScoreRnd===2">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score2">{{review.avgReviewScore}}</v-avatar>
                                                </div>
                                                <div v-else-if="review.avgReviewScoreRnd===3">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score3">{{review.avgReviewScore}}</v-avatar>
                                                </div>
                                                <div v-else-if="review.avgReviewScoreRnd===4">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score4">{{review.avgReviewScore}}</v-avatar>
                                                </div>
                                                <div v-else-if="review.avgReviewScoreRnd===5">
                                                    <v-avatar size="35" class="ml-3 logo_row_2 acco_score5">{{review.avgReviewScore}}</v-avatar>
                                                </div>                                            
                                            </div>
                                            
                                            <div v-if="review.nrOfReviews===0">
                                                <td class="sub_script">No published reviews yet</td>
                                            </div>
                                            <div v-else>
                                                <td class="sub_script">Based on {{ review.nrOfReviews }} reviews</td>
                                            </div>
                                            <div>
                                                <td class="sub_script" style="width: 60px">Key: </td>                                        
                                                <td class="sub_script pl-1">{{ review.key }}</td>
                                            </div>        
                                            <div>
                                                <td class="sub_script" style="width: 60px">Updated: </td>                                        
                                                <td class="sub_script pl-1">{{ review.updated_vfy }}</td>
                                            </div>        
                                            <div>
                                                <td class="sub_script" style="width: 60px">Uploaded: </td>                                        
                                                <td class="sub_script pl-1">{{ review.uploaded_vfy }}</td>
                                            </div>           
                                            <div>
                                                <td class="sub_script" style="width: 60px">Open for: </td>                                        
                                                <td class="sub_script pl-1">business days: {{ review.running_businessdays }}, calendar days: {{ review.running_normaldays }} </td>
                                            </div>                                                                   
                                        </td>
                                    </tr>
                                </table>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="mt-8">
                        <v-card flat class="mr-8">
                            <v-container>
                                <v-row cols="12">
                                    <v-col cols="8" class="mt-1">
                                        <v-layout justify-end>                                          
                                            <span v-if="!!this.mails">
                                                <v-badge color="grey lighten-2" overlap bordered offset-y="35" offset-x="10">
                                                    <template v-slot:badge>
                                                        <span>{{mails}}</span> <!-- 0 = false; <> 0 = true -->
                                                    </template>                                                
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon v-bind="attrs" v-on="on" class="pointer_hand" v-on:click="revwmails()">mdi-email-multiple-outline</v-icon>
                                                        </template>
                                                        <span>View sent e-mails</span>
                                                    </v-tooltip>    
                                                </v-badge>
                                            </span>         
                                            <span v-else>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs" v-on="on" class="pointer_hand">mdi-email-multiple-outline</v-icon>
                                                    </template>
                                                    <span>View sent e-mails</span>
                                                </v-tooltip> 
                                            </span>                                                  
                                            <span v-if="!!this.notes">
                                                <v-badge color="grey lighten-2" overlap bordered offset-y="35" offset-x="10">
                                                    <template v-slot:badge>
                                                        <span>{{notes}}</span> <!-- 0 = false; <> 0 = true -->
                                                    </template>                                                
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-6" v-on:click="nott(review.table, review.encrid)">mdi-note-multiple-outline</v-icon>
                                                        </template>
                                                        <span>View notes</span>
                                                    </v-tooltip>  
                                                </v-badge>
                                            </span>           
                                            <span v-else>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-6" v-on:click="nott(review.table, review.encrid)">mdi-note-multiple-outline</v-icon>
                                                    </template>
                                                    <span>View notes</span>
                                                </v-tooltip>                                                  
                                            </span>                                                                              
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-8" v-on:click="send(review)">mdi-email-plus-outline</v-icon>
                                                </template>
                                                <span>Send e-mail to contact</span>
                                            </v-tooltip>       
                                        </v-layout>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-layout justify-end>
                                            <v-avatar size="60" :color="score_color">
                                                <div>
                                                    <h1>{{ review.score }}</h1>
                                                </div>
                                            </v-avatar>
                                        </v-layout>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row cols="12" no-gutters dense>
                    <v-col cols="6">
                        <v-card class="ml-6" flat>
                            <v-container>
                                <div v-if="review.table === 'hogr'"
                                    @click="$router.open('/huov/onHuov/' + review.huov_encrid)">
                                    <h4>Booking <a> {{ review.huov_code }} </a></h4>
                                </div>
                                <div v-else>
                                    <div v-if="review.copy">
                                        <h4 v-if="review.huov_code!==''">Booking<a> {{ review.huov_code }} </a></h4>
                                        <h4 v-else>Booking</h4>
                                    </div>
                                    <div v-else>
                                        <h4 v-if="review.huov_code!==''">Partner booking: {{ review.ota_huov_code }} (VfY: <a @click="$router.open('/huov/onHuov/' + review.huov_encrid)"> {{ review.huov_code }} </a>)</h4>
                                        <h4 v-else>Partner booking</h4>
                                    </div>
                                </div>                                
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="6">
                        <v-card class="mr-8" flat>
                            <v-container>
                                <v-divider></v-divider>
                                <div v-if="review.url !== ''">Visit accommodation {{ review.huis_code }} on <a
                                        :href=review.url target="_blank">{{ review.source }}</a></div>
                                <div v-else style="color: lightgrey;">No url available to visit this accommodation
                                    online</div>
                            </v-container>
                        </v-card>
                    </v-col>                       
                </v-row>
                <v-row cols="12" no-gutters class="ml-3 mt-6">
                    <v-col cols="1" class="mx-1 pl-5">
                        <div v-if="review.table === 'hogr'">
                            <v-select v-model="review.score" :items="scoreKeuzes" item-value="code" item-text="desc"
                                label="Score" dense>
                            </v-select>
                        </div>
                        <div v-else>
                            <v-text-field v-model="review.score" label="Score" dense readonly class="text-field-style">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-2">
                        <v-select v-model="review.status" :items="statusKeuzes" item-value="code" item-text="desc"
                            label="Status" dense>
                        </v-select>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-2">
                        <v-text-field v-model="review.created" label="Date / Time" dense readonly
                            class="text-field-style text-grey">
                        </v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-2">
                        <v-select v-model="review.gebr_code" v-bind:items="gebr" item-value="code" item-text="name"
                            label="Assigned to" dense class="px-6"></v-select>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-2">
                        <v-text-field v-model="review.huis_code"
                            @click="$router.open('/huis/onHuis/' + review.huis_encrid)" label="Accommodation" dense
                            readonly class="text-field-style_a"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-3" v-if="review.table === 'hogr'">
                        <v-text-field v-model="review.klnt_naam"
                            @click="$router.open('/klnt/onKlnt/' + review.klnt_encrid)" label="Guest" dense readonly
                            class="text-field-style_a"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1 pl-3" v-else>
                        <v-text-field v-model="review.klnt_naam" label="Guest" dense readonly class="text-field-style">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card flat class="ml-6">
                        <v-row no-gutters>
                            <v-col cols=12>
                                <div v-if="links.length > 0">
                                    <span class="ml-3">
                                        <span v-for="(link, idx) in links" :key="idx">
                                            <span v-html="link.url"></span><span>&nbsp;<v-icon small
                                                    v-on:click="deleteLink(link.id)">
                                                    mdi-trash-can-outline</v-icon>
                                                &nbsp;&nbsp;</span>
                                        </span>
                                        <span v-if="links != null && links.length > 0">&nbsp;</span>
                                        <v-btn small plain v-on:click="createlink()">create link</v-btn>                                        
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-if="links != null && links.length > 0">&nbsp;</span>
                                    <v-btn small plain v-on:click="createlink()">create link</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                </v-card>
                <v-card-text>
                    <v-card height="350px" flat>
                            <v-card-text>
                                <div v-if="review.klnt_taal_code!==review.use_taal_code||review.cttp_nr==='5'" class="mb-3" style="display: flex; flex-direction: row; align-items: center;">
                                    <div v-if="review.klnt_taal_code!==review.use_taal_code" style="display: flex; flex-direction: row; align-items: center; margin-right: 20px;">
                                        <v-icon medium color="success" class="pr-1 pl-1">mdi-alpha-t-circle</v-icon>
                                        <div style="font-size: medium; font-weight: 400; font-style: italic;">{{ `Translated from ${review.klnt_taal_code} to ${review.use_taal_code}` }}</div>
                                    </div>
                                    <div v-if="review.cttp_nr==='5'" style="display: flex; flex-direction: row; align-items: center;">
                                        <v-icon medium color="error" class="pr-1 pl-1">mdi-alpha-e-circle</v-icon>
                                        <div style="font-size: medium; font-weight: 400; font-style: italic;">{{ review.cttp_description }}</div>
                                    </div>                                    
                                </div>
                                <div v-if="review.table === 'hogr'">
                                    <ul class="ul_style">
                                        <li>
                                            <v-textarea v-model="review.gastenboek" :value="review.gastenboek"
                                                label="Review text" auto-grow class="mr-2 ml-1" counter no-resize>
                                            </v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.tips_host" :value="review.tips_host"
                                                label="Tips for the host" auto-grow class="mr-2 ml-1" counter no-resize>
                                            </v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.tips_vfy" :value="review.tips_vfy"
                                                label="Tips for Villa for You" auto-grow class="mr-2 ml-1" counter
                                                no-resize></v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.reaction_host" :value="review.reaction_host"
                                                label="Reaction host" auto-grow class="mr-2 ml-1" counter
                                                no-resize></v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.reaction_vfy" :value="review.reaction_vfy"
                                                label="Reaction Villa for You" auto-grow class="mr-2 ml-1" counter
                                                no-resize></v-textarea>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    <ul class="ul_style">
                                        <li>
                                            <v-textarea v-model="review.gastenboek" :value="review.gastenboek"
                                                label="Review text" auto-grow class="mr-2 ml-1" counter readonly
                                                no-resize></v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.reaction_host" :value="review.reaction_host"
                                                label="Reaction host" auto-grow class="mr-2 ml-1" counter
                                                readonly no-resize></v-textarea>
                                        </li>
                                        <li>
                                            <v-textarea v-model="review.reaction_vfy" :value="review.reaction_vfy"
                                                label="Reaction Villa for You" auto-grow class="mr-2 ml-1" counter
                                                readonly no-resize></v-textarea>
                                        </li>
                                    </ul>
                                </div>
                            </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small class="primary ma-2" @click="saveReview()">Save</v-btn>
                    <v-btn small class="primary ml-2 mr-8" @click="closeDialog()">Close</v-btn>
                </v-card-actions>

            </v-container>
        </v-card>
        <create_link ref="create_link" />
        <nott ref="nott"/>
        <send_review ref="send_review"/>
        <revw_mails ref="revw_mails"/>
    </v-dialog>
</template>
  
<script>

import { bus } from "../../../../main";
import mxgetuser from '@/mixins/getuser';
import mximage from "@/mixins/responsive_image"
import mxfindwithattribute from '@/mixins/findwithattribute';
import create_link from '@/components/create_link.vue';
import nott from "@/components/nott.vue";
import send_review from "@/views/task/customer_success/revw/sendReview.vue";
import revw_mails from "@/views/task/customer_success/revw/showRevwMail.vue";

export default {

    components: {
        create_link,
        nott,
        send_review,
        revw_mails,
    },
    data() {
        return {
            dialog: false,
            review: {},
            item: {},
            notes: 0,
            mails: 0,
            table: '',
            encrid: '',
            scoreKeuzes: [],
            colors: [],
            statusKeuzes: [],
            links: [],
        }
    },
    created() {
        this.aquireImages();
        bus.$on("createlink", (data) => {
            this.links = data;
        });
        bus.$on("addNote", (data) => {
            this.notes += data;
        });        
        bus.$on("sendReview", (data) => {
            this.mails += data;
        });                        
    },
    mounted() {
    },
    mixins: [mxgetuser, mxfindwithattribute, mximage],
    computed: {
        score_color: function () {
            var idx = this.findWithAttr(this.colors, "code", this.review.score); // code, name zoeken in, naar, met waarde
            if (idx !== -1) {
                return this.colors[idx].color;
            }
            return this.review.color_code;
        },
    },
    methods: {
        notifyParent(param) {
            bus.$emit("updateReviewList", param);
        },
        aquireImages(){
            this.loadImage(require('@/assets/_airbnb.svg'), 'airbnb', 50);
            this.loadImage(require('@/assets/_bookingcom.svg'), 'booking', 50);
            this.loadImage(require('@/assets/_vrbo_logo.svg'), 'vrbo', 50);
            this.loadImage(require('@/assets/_vfy_logo.svg'), 'vfy', 50);
            this.loadImage(require('@/assets/_holidu_logo.svg'), 'holidu', 50);            
        },
        open(review) {
            this.review = {};
            this.scoreKeuzes = [];
            this.statusKeuzes = [];
            this.colors = [];
            this.table = review.item.table;
            this.encrid = review.item.encrid;
            this.loading = false;
            this.notes = 0;
            this.mails = 0;
            this.item = review;
            this.getGebr();
            this.getReview();
        },
        saveReview() {
            this.review.links = this.links;
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/saveReview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveReview"
                    },
                    saveReview: this.review,
                    // links: this.links,
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log("test");
                        var idx = this.findWithAttr(this.gebr, "code", this.review.gebr_code); // code, name zoeken in, naar, met waarde
                        if (idx !== -1) {
                            this.review.display_name = this.gebr[idx].name;
                        }
                        this.review.color_code = this.score_color;
                        this.notifyParent(this.review);
                        this.closeDialog();
                    }
                })
        },
        actionClick(action) {
            switch (action) {
                case "mergeHogr": this.$refs.mergeHogr.open(this.hogr_encrid); break;
            }
        },
        revwmails(){
            this.$refs.revw_mails.open(this.review);
        },              
        nott(table, encrid) {
            console.log(table, encrid);
            this.$refs.nott.open(table, encrid, "all");
        },
        closeDialog() {
            this.dialog = false;
        },
        createlink() {
            this.$refs.create_link.open(this.links);
        },
        send(review) {
            this.$refs.send_review.open(review);
        },        
        getReview() {
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getReview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReview"
                    },
                    getReview: {
                        table: this.table,
                        encrid: this.encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log(res.data.getReview);
                        this.scoreKeuzes = res.data.getReview.scoreKeuzes;
                        this.statusKeuzes = res.data.getReview.statusKeuzes;
                        this.colors = res.data.getReview.colors;
                        this.review = res.data.getReview;
                        this.links = res.data.getReview.links;
                        this.notes = res.data.getReview.nott_aant;
                        this.mails = res.data.getReview.mail_aant;
                        this.dialog = true;
                    }
                    this.$emit('review-loaded', this.item);
                });
        }
    }

};

</script> 
  
<style scoped>
    .text-field-style>>>.v-text-field__slot input {
        color: grey;
        font-weight: 300;
        /* 800 being bold so this is less than half bold */
        cursor: default !important;
    }
    .text-field-style_a>>>.v-text-field__slot input {
        color: black;
        font-weight: 300;
        /* 800 being bold so this is less than half bold */
        cursor: pointer !important;
    }
    .text-grey {
        color: grey !important;
        font-weight: 400 !important;
        /* 800 being bold so this is half bold */
    }    
    .sub_script {
        font-size: 11px !important;
    }
    .acco_score0 {
        background: transparent !important;
        border: 2px solid lightgrey;
    }
    .acco_score1 {
        background: transparent !important;
        border: 2px solid #FD535E;
    }
    .acco_score2 {
        background: transparent !important;
        border: 2px solid #FD7B3F;
    }
    .acco_score3 {
        background: transparent !important;
        border: 2px solid #FCC700;
    }
    .acco_score4 {
        background: transparent !important;
        border: 2px solid #65D557;
    }
    .acco_score5 {
        background: transparent !important;
        border: 2px solid #0FC771;
    }
    .logo_row_2 {
        cursor: pointer;
    }
    .pointer_hand{
        cursor: pointer;
    }
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 325px;
        overflow-y: auto;
    }
</style>